// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_f0-0";